module.exports = __webpack_public_path__ + "static/gingerbeer-c0fc980207b60c906927aaa6cae347e7.jpg";